/**
 * Mega Navigation - Desktop Interactions
 * Handles dropdown visibility and content switching
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Function to attach hover handlers - defined outside init so it can be reused
  function attachHoverHandlers() {
    const linkParents = document.querySelectorAll('.site-nav-dropdown__link-parent[data-handle]');
    linkParents.forEach(linkParent => {
      // Remove any existing listeners by cloning (clean slate)
      if (!linkParent.hasAttribute('data-hover-attached')) {
        linkParent.setAttribute('data-hover-attached', 'true');
        linkParent.addEventListener('mouseenter', function(e) {
          handleLeftLinkHover({ currentTarget: linkParent });
        });
      }
    });
  }

  function init() {
    const navItems = document.querySelectorAll('[data-nav-item]');
    const leftLinks = document.querySelectorAll('[data-meganav-toggle]');
    
    // Setup left link toggles for content switching (click)
    leftLinks.forEach(link => {
      link.addEventListener('click', handleLeftLinkClick);
    });

    // Attach hover handlers initially
    attachHoverHandlers();

    // Setup hover/click interactions for nav items
    navItems.forEach(item => {
      const toggle = item.querySelector('[data-hover-disclosure-toggle]');
      if (toggle) {
        setupNavItemHover(item, toggle);
        // Initialize dropdown when nav item is set up
        const dropdownId = toggle.getAttribute('aria-controls');
        const dropdown = document.getElementById(dropdownId);
        if (dropdown) {
          const megaNavDropdown = dropdown.querySelector('.site-nav-dropdown__menu') || dropdown.querySelector('.site-nav-dropdown');
          if (megaNavDropdown) {
            setupDropdown(megaNavDropdown);
          }
        }
      }
    });
  }

  function setupDropdown(dropdown) {
    // dropdown is .site-nav-dropdown__menu (or .site-nav-dropdown), search within it
    const menu = dropdown.classList.contains('site-nav-dropdown__menu') ? dropdown : dropdown.querySelector('.site-nav-dropdown__menu') || dropdown;

    // Prefer activating the link that matches the current collection (when on a collection page)
    const headerDropdown = dropdown.closest('.header__dropdown');
    const collectionHandle = headerDropdown ? headerDropdown.getAttribute('data-collection-handle') : null;

    // Activate first left link by default, or the one matching current collection
    const allLinkParents = menu.querySelectorAll('.site-nav-dropdown__link-parent');
    let linkToActivate = null;

    if (collectionHandle) {
      for (let i = 0; i < allLinkParents.length; i++) {
        const link = allLinkParents[i];
        if (link.classList.contains('site-nav-dropdown__button')) continue;
        const handle = link.getAttribute('data-handle');
        if (!handle) continue;
        if (handle === collectionHandle || (collectionHandle.indexOf(handle) === 0)) {
          linkToActivate = link;
          break;
        }
      }
    }

    if (!linkToActivate) {
      for (let i = 0; i < allLinkParents.length; i++) {
        const link = allLinkParents[i];
        if (!link.classList.contains('site-nav-dropdown__button')) {
          linkToActivate = link;
          break;
        }
      }
    }
    if (!linkToActivate && allLinkParents.length > 0) {
      linkToActivate = allLinkParents[0];
    }

    if (linkToActivate) {
      linkToActivate.classList.add('site-nav-dropdown__child-link--active');
      const trigger = linkToActivate.querySelector('button, a.site-nav-dropdown__link-button');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
      const handle = linkToActivate.getAttribute('data-handle');
      const targetBlock = handle ? (dropdown.querySelector(`#${CSS.escape(handle)}`) || dropdown.querySelector(`[id="${handle.replace(/"/g, '\\"')}"]`)) : null;
      dropdown.querySelectorAll('.site-nav-dropdown__child-menu').forEach(block => {
        block.classList.remove('site-nav-dropdown__child-menu--active');
      });
      if (targetBlock) {
        targetBlock.classList.add('site-nav-dropdown__child-menu--active');
      } else {
        const firstContentBlock = dropdown.querySelector('.site-nav-dropdown__child-menu');
        if (firstContentBlock) {
          firstContentBlock.classList.add('site-nav-dropdown__child-menu--active');
        }
      }
    } else {
      const firstContentBlock = dropdown.querySelector('.site-nav-dropdown__child-menu');
      if (firstContentBlock) {
        dropdown.querySelectorAll('.site-nav-dropdown__child-menu').forEach(block => {
          block.classList.remove('site-nav-dropdown__child-menu--active');
        });
        firstContentBlock.classList.add('site-nav-dropdown__child-menu--active');
      }
    }
  }

  function switchToContentBlock(linkContainer) {
    if (!linkContainer) return;
    
    const handle = linkContainer.getAttribute('data-handle');
    if (!handle) {
      console.warn('No data-handle found on link container');
      return;
    }

    // Find the dropdown container (menu that holds links + content blocks)
    let dropdown = linkContainer.closest('.site-nav-dropdown__menu') || linkContainer.closest('.site-nav-dropdown');
    if (!dropdown) {
      const headerDropdown = linkContainer.closest('.header__dropdown');
      if (headerDropdown) {
        dropdown = headerDropdown.querySelector('.site-nav-dropdown__menu') || headerDropdown.querySelector('.site-nav-dropdown');
      }
    }
    
    if (!dropdown) {
      console.warn('Could not find dropdown container', linkContainer);
      console.warn('Link container parent:', linkContainer.parentElement);
      console.warn('Link container ancestors:', linkContainer.closest('.header__dropdown'));
      return;
    }

    // Remove active state from all left links in this dropdown
    dropdown.querySelectorAll('.site-nav-dropdown__link-parent').forEach(link => {
      link.classList.remove('site-nav-dropdown__child-link--active');
      const trigger = link.querySelector('button, a.site-nav-dropdown__link-button');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    // Add active state to current link
    linkContainer.classList.add('site-nav-dropdown__child-link--active');
    const trigger = linkContainer.querySelector('button, a.site-nav-dropdown__link-button');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    // Hide all content blocks - search within dropdown or menu
    const allBlocks = dropdown.querySelectorAll('.site-nav-dropdown__child-menu');
    allBlocks.forEach(block => {
      block.classList.remove('site-nav-dropdown__child-menu--active');
    });

    // Show the matching content block - search within the entire dropdown
    const escapedHandle = CSS.escape(handle);
    let targetBlock = dropdown.querySelector(`#${escapedHandle}`) || dropdown.querySelector(`[id="${handle.replace(/"/g, '\\"')}"]`);
    if (!targetBlock) {
      const grid = dropdown.querySelector('.site-nav-dropdown__grid');
      if (grid) {
        targetBlock = grid.querySelector(`#${escapedHandle}`) || grid.querySelector(`[id="${handle.replace(/"/g, '\\"')}"]`);
      }
    }
    if (!targetBlock && allBlocks.length > 0) {
      allBlocks[0].classList.add('site-nav-dropdown__child-menu--active');
      return;
    }
    if (targetBlock) {
      targetBlock.classList.add('site-nav-dropdown__child-menu--active');
    }
  }

  function handleLeftLinkClick(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const linkContainer = button.closest('.site-nav-dropdown__link-parent');
    switchToContentBlock(linkContainer);
  }

  function handleLeftLinkHover(e) {
    const linkContainer = e.currentTarget;
    if (linkContainer && linkContainer.classList.contains('site-nav-dropdown__link-parent')) {
      switchToContentBlock(linkContainer);
    }
  }

  function setupNavItemHover(item, toggle) {
    const dropdownId = toggle.getAttribute('aria-controls');
    const dropdown = document.getElementById(dropdownId);
    if (!dropdown) return;

    const megaNavDropdown = dropdown.querySelector('.site-nav-dropdown__menu') || dropdown.querySelector('.site-nav-dropdown');
    if (!megaNavDropdown) return;

    // Theme shows dropdown via .menu__item.is-visible; we only need to set the active panel when it opens
    function showDropdown() {
      setupDropdown(megaNavDropdown);
      attachHoverHandlers();
    }

    // Mouse events - run setup when user hovers so correct panel is shown
    item.addEventListener('mouseenter', showDropdown);
    megaNavDropdown.addEventListener('mouseenter', showDropdown);

    // Click events for mobile/tablet - theme handles open/close via is-visible
    toggle.addEventListener('click', function(e) {
      showDropdown();
    });

    // Keyboard - ensure panel is set when dropdown opens
    toggle.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        showDropdown();
      }
    });
  }

  // Theme handles closing dropdowns via is-visible; no need to toggle opacity/tw-hidden here
})();
